import React, { useState } from 'react';
import { Box, TextField, Button, Typography, Paper, Alert } from '@mui/material';
import SendIcon from '@mui/icons-material/Send';
import DangerousIcon from '@mui/icons-material/Dangerous';
import AADService from "../funcionesAuth.js";

const ConsultasSql = () => {
  const [sqlQuery, setSqlQuery] = useState('');
  const [response, setResponse] = useState(null);
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  let idusuario = localStorage.getItem("idusuario");
  // Lista de comandos prohibidos
  const forbiddenCommands = [
    'DELETE', 'DROP', 'TRUNCATE', 
    'ALTER', 'CREATE', 'GRANT',
    'REVOKE'
  ];
  const AzureADService = new AADService();
  const token = AzureADService.getToken();
  
  const handleExecute = async () => {
    setError(null);
    setResponse(null);
    
    // Validar consulta SQL
    const upperQuery = sqlQuery.toUpperCase();
    console.log("asd",upperQuery)
    const isForbidden = forbiddenCommands.some(cmd => upperQuery.includes(cmd));
    
    if (isForbidden) {
      setError('Operación no permitida: Comandos peligrosos detectados');
      return;
    }

    if (!sqlQuery.trim()) {
      setError('Por favor ingrese una consulta SQL válida');
      return;
    }

    try {
      setIsLoading(true);
      
      // Llamada a la API
      const res = await fetch(`${process.env.REACT_APP_API_URL}maestro/contingencia/`, {
        method: 'POST',
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
        },
        body: JSON.stringify({ "query": sqlQuery, "idusuario": idusuario })
      });

      const data = await res.json();
      
      if (!res.ok) {
        throw new Error(data.message || 'Error al ejecutar la consulta');
      }

      setResponse(data);
    } catch (err) {
      setError(err.message);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Box sx={{ p: 4 }}>
      <Typography variant="h4" gutterBottom>
        Editor SQL
      </Typography>
      
      <Paper elevation={3} sx={{ p: 3, mb: 3 }}>
        
        <TextField
          fullWidth
          multiline
          rows={6}
          variant="outlined"
          placeholder="Ejemplo: SELECT * FROM usuarios WHERE activo = true"
          value={sqlQuery}
          onChange={(e) => setSqlQuery(e.target.value)}
          sx={{ mb: 2 }}
        />
        
        <Box sx={{ display: 'flex', gap: 2 }}>
          <Button
            variant="contained"
            color="primary"
            endIcon={<SendIcon />}
            onClick={handleExecute}
            disabled={isLoading}
          >
            {isLoading ? 'Ejecutando...' : 'Ejecutar'}
          </Button>
          
          <Button
            variant="outlined"
            color="error"
            startIcon={<DangerousIcon />}
            onClick={() => {
              setSqlQuery('');
              setResponse(null);
              setError(null);
            }}
          >
            Limpiar
          </Button>
        </Box>
      </Paper>
      
      {error && (
        <Alert severity="error" sx={{ mb: 3 }}>
          {error}
        </Alert>
      )}
      
      {response && (
        <Paper elevation={3} sx={{ p: 3 }}>
          <Typography variant="h6" gutterBottom>
            Resultados
          </Typography>
          <pre style={{ 
            backgroundColor: '#f5f5f5', 
            padding: '16px', 
            borderRadius: '4px',
            overflowX: 'auto'
          }}>
            {JSON.stringify(response, null, 2)}
          </pre>
        </Paper>
      )}
    </Box>
  );
};

export default ConsultasSql;